<template>
  <MessageView
    title="Could Not Fetch Issues"
    message="There was a problem retrieving the sensor issues."
  />
</template>

<script>
import MessageView from "./components/MessageView.vue";
export default {
  name: "ErrorView",
  components: { MessageView },
};
</script>


